module.exports = __webpack_public_path__ + "400a081a9942ebd7f4b99a51741a1b01.png";